import axios from 'axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();
const serverUrl = () => process.env.REACT_APP_SERVER_URL_API || 'http://localhost:8090';

// Même rationale que ordersApi.js/ticketApi.js : une instance dédiée qui lit
// le cookie à chaque requête plutôt que de dépendre de l'intercepteur global de TokenContext.
const client = axios.create();
client.interceptors.request.use((config) => {
    const token = cookies.get('DASHBOARD_ACCESS');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export async function updateProfile(data) {
    const { data: result } = await client.put(`${serverUrl()}/api/user`, data);
    return result;
}

export async function updateCompany(data) {
    const { data: result } = await client.put(`${serverUrl()}/api/company`, data);
    return result;
}

export async function getCompanyUsers() {
    const { data } = await client.get(`${serverUrl()}/api/company/users`);
    return data;
}

export async function requestPasswordResetCode() {
    const { data } = await client.post(`${serverUrl()}/api/user/password-reset/request`);
    return data;
}

export async function confirmPasswordReset(code, newPassword) {
    const { data } = await client.post(`${serverUrl()}/api/user/password-reset/confirm`, {
        code,
        new_password: newPassword
    });
    return data;
}
